// Load slick carousel globally.
import 'slick-carousel';

// Load bootstrap bundle globally.
import 'bootstrap/dist/js/bootstrap.bundle';

// moment.js is required for daterangepicker but is not loadable using npm, see page.typoscript.

// Load jQuery and make it globally available.
import $ from 'jquery';
window.$ = $;
window.jQuery = $;

// Import modules at runtime to make sure $ is loaded.
// TODO: would be better if modules are only loaded if required, not always!
import('./workshop.js').then((module) => {
	window.DEBUG && console.log('Module loaded', 'workshop');
});
import('./history.js').then((module) => {
	window.DEBUG && console.log('Module loaded', 'history');
});
import('./modal.js').then((module) => {
	window.DEBUG && console.log('Module loaded', 'modal');
});
import('./news.js').then((module) => {
	window.DEBUG && console.log('Module loaded', 'news');
});
import('./searchForm.js').then((module) => {
	window.DEBUG && console.log('Module loaded', 'searchForm');
});
import('./youtube.js').then((module) => {
	window.DEBUG && console.log('Module loaded', 'youtube');
});
import('./lazyBackgroundImages.js').then((module) => {
	window.DEBUG && console.log('Module loaded', 'lazyBackgroundImages');
});
import('./keyup.js').then((module) => {
	window.DEBUG && console.log('Module loaded', 'keyup');
});

$(window).on('load', function () {
	$('#page-loader').fadeOut(500,function() {
		$(this).remove();
	});
});

function loadjscssfile(filename, filetype)
{
	if (filetype === "js") {
		var fileref = document.createElement('script');
		fileref.setAttribute("type", "text/javascript");
		fileref.setAttribute("src", filename);
		if (typeof fileref != "undefined") {
			document.body.appendChild(fileref);
		}
	}
	else if (filetype === "css") {
		var fileref = document.createElement("link");
		fileref.setAttribute("rel", "stylesheet");
		fileref.setAttribute("type", "text/css");
		fileref.setAttribute("href", filename);
		if (typeof fileref != "undefined") {
			document.getElementsByTagName("head")[0].appendChild(fileref);
		}
	}
}

function scrollTo(top) {

	// cache document of dom
	var page = $("html, body");

	// current height of header
	var headerHeight = top == 0 ? 0 : $("header").height();

	// stop animated scrolling if user is srolled manually
	page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
		page.stop();
	});

	// animate scrolling
	page.animate({ scrollTop: top - headerHeight }, 'slow', function(){
		page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
	});

	return false;
}

function setHeightOfTextBoxes() {
	$('.has-2-columns').each(function () {
		if($(this).find('.text-box').length > 1) {
			var heightTextColumns = 0;
			$(this).find('.text-box').attr('style', '');
			if($(window).width() > 767) {
				$(this).find('.text-box').each(function () {
					if ($(this).height() > heightTextColumns) {
						heightTextColumns = $(this).height();
					}
				});
				$(this).find('.text-box').height(heightTextColumns);
			}
		}
	});

	$('.has-3-columns').each(function () {
		if($(this).find('.text-image-card').length > 1) {
			var heightOfTextImageCards = 0;
			$(this).find('.text-image-card').attr('style', '');
			if ($(window).width() > 767 && $(window).width() < 992) {
				$(this).find('.text-image-card').each(function () {
					if ($(this).height() > heightOfTextImageCards) {
						heightOfTextImageCards = $(this).height();
					}
				});
				$(this).find('.text-image-card').height(heightOfTextImageCards);
			} else if ($(window).width() >= 992) {
				var rowMatrix = [];
				$(this).find('.col-lg-4').each(function(i,v) {
					var column = i;
					rowMatrix[column] = [];
					$(this).find(".text-image-card").each(function(i,v) {
						rowMatrix[column][i] = $(this);
					})
				});

				var maxLengthRows = rowMatrix[0].length;
				for(var i= 0;i<maxLengthRows;i++) {
					var heightOfTextImageCards = 0;
					$.each(rowMatrix, function(c,v) {
						if (v[i]) {
							if (v[i].height() > heightOfTextImageCards) {
								heightOfTextImageCards = v[i].height();
							}
						}
					});
					$.each(rowMatrix, function(c,v) {
						if (v[i]) {
							v[i].height(heightOfTextImageCards);
						}
					});
				}

			}
		}
	});
}

function setHeightOfNewsCards() {
	if($('.row.has-2-columns .newsletter-box').length > 0) {
		$('.row.has-2-columns').each(function() {
			if($(this).find('.newsletter-box').length > 0) {
				var boxesHeight = 0;
				var boxes = $(this).find('.newsletter-box__content');
				boxes.attr('style', '');
				boxes.each(function () {
					var objectHeight = $(this).height();
					if (boxesHeight < objectHeight) {
						boxesHeight = objectHeight;
					}
				});
				boxes.height(boxesHeight);
			}
		});
	}
}

function setHeightOfTeaserBoxes() {
	if($('.teaser-box').length > 1) {
		var heightOfTeaserBox = 0;
		$('.teaser-box').attr('style', '');
		if($(window).width() > 767) {
			$('.teaser-box').each(function () {
				if ($(this).height() > heightOfTeaserBox) {
					heightOfTeaserBox = $(this).height();
				}
			});
			$('.teaser-box').height(heightOfTeaserBox);
		}
	}
}

$(document).ready( function () {
	'use strict';

	if(window.location.hash) {
		if($('[data-anchor="!'+window.location.hash+'"]').length > 0) {
			if($('[data-anchor="!'+window.location.hash+'"]').attr('data-toggle')) {
				$($('[data-anchor="!'+window.location.hash+'"]').data("target")).collapse('show');
			}
			scrollTo($('[data-anchor="!'+window.location.hash+'"]').offset().top);
		}
	}

	let videoElement = $('.cbf-movie');
	if (videoElement.length > 0) {
		videoElement.each(function () {
			let videoItem = $(this);
			let videoUrl = videoItem.data('video-url')
			if(videoUrl){
				let videoIframe =  videoItem.find('iframe');
				videoItem.on('click','.video__placeholder', function () {
					$(this).fadeOut();
					videoIframe.attr('src', videoUrl);
				})
			}
			else
			{
				let videoElem = videoItem.find('video');
				if (videoElem.attr('autoplay')) {
					videoItem.find('.video__placeholder').fadeOut();
				}
				videoItem.on('click','.video__placeholder', function () {
					$(this).fadeOut();
					videoElem.trigger('play');
				})
			}
		});
	}


	$('.lang-nav .current').on('click', function(e) {
		e.preventDefault();
		$(this).parent().toggleClass('open');
	});

	$('a').on('click', function(e) {
		var url =  this.href,
				hash = url.split('#')[1];
		if(url.indexOf("#") != -1) { // .test() returns a boolean
			if($('[data-anchor="!#'+hash+'"]').length > 0) {
				e.preventDefault();
				if($('[data-anchor="!#'+hash+'"]').attr('data-toggle')) {
					$($('[data-anchor="!#'+hash+'"]').data("target")).collapse('show');
				}
				scrollTo($('[data-anchor="!#'+hash+'"]').offset().top);
			}
		}
	});

	$('[data-action="toggleMenu"]').on('click', function (e) {
		e.preventDefault();
		if($(doc).hasClass('open-menu')) {
			$('ul.nav-level-1 > li.open-sub').length > 0 ? $('ul.nav-level-1 > li.open-sub').removeClass('open-sub') : '';
		} else {
			$('ul.nav-level-2 a.current').length > 0 ? $('ul.nav-level-2 a.current').parent().parent().parent().parent().addClass('open-sub') : '';
		}

		$('html').toggleClass('open-menu');
	});

	$('a.sub[data-navlvl="first"]').on('click touchend', function (e) {
		e.preventDefault();

		if($(this).parent().hasClass('open-sub')) {
			$(this).parent().removeClass('open-sub');
		} else {
			$('ul.nav-level-1 > li.open-sub').length > 0 ? $('ul.nav-level-1 > li.open-sub').removeClass('open-sub') : '';
			$(this).parent().addClass('open-sub');
		}
	});

	$('[data-action="toggleModalShare"]').on('click', function (e) {
		e.preventDefault();
		$('html').toggleClass('open-share-modal');
	});
	var doc = document.documentElement;
	var topOffset  = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
	var topTopButton = $('[data-action="to-top"]');
	var htmlObject = $('html');
	$(window).on('scroll', function() {
		if( $('html').hasClass('open-menu') ) {
			$('html').removeClass('open-menu');
		}
		doc = document.documentElement;
		topOffset  = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
		if(topOffset > $(window).height() && !topTopButton.hasClass('show')) {
			topTopButton.addClass('show');
		} else if(topOffset < $(window).height() && topTopButton.hasClass('show')) {
			topTopButton.removeClass('show');
		}

		if(topOffset > 10 && !htmlObject.hasClass('small-header')) {
			htmlObject.addClass('small-header');
		} else if(topOffset < 10 && htmlObject.hasClass('small-header')) {
			htmlObject.removeClass('small-header');
		}
	});

	topTopButton.on('click', function(e) {
		e.preventDefault();
		scrollTo(0);
	});

	if($('.hero-image').length > 0) {
		var dots = false;
		if($('.hero-image-slide').length > 1) {
			dots = true;
		}
		$('.hero-image').slick({
			dots: dots,
			arrows: false,
			infinite: true,
			speed: 600,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 3000
		});
	}

	if($('.content-slider:not(.content-slider--content):not(.content-slider--no-dots)').length > 0) {
		$('.content-slider:not(.content-slider--content):not(.content-slider--no-dots)').slick({
		   dots: true,
		   arrows: false,
		   infinite: true,
		   speed: 600,
		   slidesToShow: 1,
		   slidesToScroll: 1,
		   autoplay: true,
		   autoplaySpeed: 3000
	   });
	}
	if($('.content-slider.content-slider--content').length > 0) {
		$('.content-slider.content-slider--content').slick({
			 dots: false,
			 arrows: true,
			 infinite: true,
			 speed: 600,
			 slidesToShow: 1,
			 slidesToScroll: 1,
			 autoplay: true,
			   prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="icon-arrow"></i></button>',
			   nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="icon-arrow"></i></button>',
			   autoplaySpeed: 3000
		 });
	}
	if($('.content-slider.content-slider--no-dots').length > 0) {
		$('.content-slider.content-slider--no-dots').slick({
			 dots: false,
			 arrows: true,
			 infinite: true,
			 speed: 600,
			 slidesToShow: 1,
			 slidesToScroll: 1,
			 autoplay: true,
			   prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="icon-arrow"></i></button>',
			   nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="icon-arrow"></i></button>',
			   autoplaySpeed: 3000
		 });
	}

	if($('.process-list').length > 0) {
		$('.process-list').each(function () {
			'use strict';

			var cProcess = $(this);
			var recordUid = cProcess.data("record-uid");

			$('.process-list__slider-'+recordUid).slick({
			    slidesToShow: 1,
			    slidesToScroll: 1,
			    arrows: true,
				fade: false,
				infinite: false,
				autoplay:false,
				prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="icon-arrow"></i></button>',
				nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="icon-arrow"></i></button>',
			    asNavFor: '.process-list__navigation-'+recordUid
		   });
			$('.process-list__slider-'+recordUid).on('afterChange', function(slick, currentSlide) {
				$('.process-list__navigation-'+recordUid + ' .process-list__navigation__item.is-active').removeClass('is-active');
				$('.process-list__navigation-'+recordUid + ' .process-list__navigation__item[data-slick-index="'+currentSlide.currentSlide+'"]').addClass('is-active');
			});
			$('.process-list__navigation-'+recordUid).slick({
				    slidesToShow: 6,
				    slidesToScroll: 6,
				    asNavFor: '.process-list__slider-'+recordUid,
				    dots: false,
				    centerMode: false,
					infinite: false,
					arrows: false,
				    focusOnSelect: true,
					autoplay:false,
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 4,
								slidesToScroll: 4
							}
						},
						{
							breakpoint: 600,
							settings: {
								slidesToShow: 3,
								slidesToScroll: 3
							}
						},
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2
							}
						}
					]
			});
		});
	}

	$('.tile').on('click', function (e) {
		e.preventDefault();
		$(this).toggleClass('active');
	});

	if($('.job-lt-item').length > 0) {
		var jobLTItemHeight = 0;
		$('.job-lt-item').each(function () {
			var objectHeight = $(this).height();
			if (jobLTItemHeight < objectHeight) {
				jobLTItemHeight = objectHeight;
			}
		});
		$('.job-lt-item').height(jobLTItemHeight);
	}

	if($('.tc-event-item').length > 0) {
		var eventLTItemHeight = 0;
		$('.tc-event-item').each(function () {
			var objectHeight = $(this).height();
			if (eventLTItemHeight < objectHeight) {
				eventLTItemHeight = objectHeight;
			}
		});
		$('.tc-event-item').height(eventLTItemHeight);
	}

	if($('.cbf-job-item > .cbf-job-item-inner').length > 0) {
		var jobLTItemHeight = 0;
		$('.cbf-job-item > .cbf-job-item-inner').each(function () {
			var objectHeight = $(this).height();
			if (jobLTItemHeight < objectHeight) {
				jobLTItemHeight = objectHeight;
			}
		});
		$('.cbf-job-item > .cbf-job-item-inner').height(jobLTItemHeight);
	}

	if($('[data-threesixty-folder]').length > 0) {
		loadjscssfile("/typo3conf/ext/cbf_template/Resources/Public/Frontend/assets/external-libs/3deye/jquery.reel.js", "js");
	}

	/**
	 * Media Center
	 */
	$('[data-action="open-media-center"]').on('click', function(e) {
		e.preventDefault();

		if(typeof $(this).data("image-url") !== "undefined") {
			var newImageObject = $("<img>").attr("src", $(this).data("image-url"));
			$('.media-center__lightbox__inner').prepend(newImageObject);
		} else if (typeof $(this).data("movie-id") !== "undefined") {
			var newVideoObject = $("<iframe>").attr({
				"src":"https://www.youtube-nocookie.com/embed/"+$(this).data("movie-id")+"?autohide=1&controls=1&enablejsapi=1&autoplay=1",
				"allow":"fullscreen",
				"allowfullscreen": "",
				"width": "480",
				"height":"270"
			});
			$('.media-center__lightbox__inner').prepend(newVideoObject);
		} else if(typeof $(this).data("threesixty-folder") !== "undefined") {
			var new3DObject = $("<img>").addClass('reel');
			var path = $(this).data("threesixty-folder");
			var counter = $(this).data("threesixty-counter");
			var extension = $(this).data("threesixty-extension");
			new3DObject.attr({
				"src" : path + '01.' + extension,
				 "data-images" : path + '##.' + extension,
				 "data-frames": 32,
				 "data-footage":4,
				 "data-resolution": 800,
				"data-suffix" : false
			 });
			$('.media-center__lightbox__inner').prepend(new3DObject);
			$('.media-center__lightbox__inner img').on('load', function () {
				var self = $(this);
				$.reel.scan();
			});
		}
		$('html').addClass('open-media-center-lightbox');
		$('body').one('keyup', function(e) {
			e.preventDefault();
			if(e.which == 27) {
				$('html').removeClass('open-media-center-lightbox');
				$('.media-center__lightbox__inner').html('');
				if($('.reel-cache').length > 0) {
					$('.reel-cache').remove();
				}
			}
		});
	});

	$('[data-action="toogle-media-center"]').on('click', function(e) {
		e.preventDefault();

		$('html').removeClass('open-media-center-lightbox');
		$('.media-center__lightbox__inner').html('');
		if($('.reel-cache').length > 0) {
			$('.reel-cache').remove();
		}
	});
	setHeightOfTextBoxes();

});

$(window).on('load', function() {
	setHeightOfNewsCards();
	setHeightOfTeaserBoxes();


	if($('.row--case-studies').length > 0) {
		var $rowCaseStudies = $('.row--case-studies').isotope({
		  // options
		  itemSelector: '.col-12',
		});

		$('.case-study__load-more a').on('click', function (e) {
			e.preventDefault();

			$('.case-study__not-loaded').removeClass('case-study__not-loaded');
			$rowCaseStudies.isotope('layout');
			$(this).parent().fadeOut();
		});

		if($('.select-wrapper select').length > 0) {

			$('body').on('change', '.tc-c-list__filter select', function(e){
				e.preventDefault();
				var valueIndustry = $('[name="filter[industries]"]').val();
				var valueTechnology = $('[name="filter[technology]"]').val();
				if(valueIndustry === '*' && valueTechnology === '*') {
					$rowCaseStudies.isotope({ filter: '*' });
				} else if(valueIndustry === '*' && valueTechnology !== '*') {
					$rowCaseStudies.isotope({ filter: valueTechnology });
				} else if(valueIndustry !== '*' && valueTechnology === '*') {
					$rowCaseStudies.isotope({ filter: valueIndustry });
				} else if (valueIndustry !== '*' && valueTechnology !== '*') {
					$rowCaseStudies.isotope({ filter: valueIndustry+valueTechnology });
				}
			});

			var $selection = $('.select-wrapper select').selectize();

			$.each($selection, function (i, v) {
				var selectionObject = $selection[i].selectize;
				selectionObject.onMouseDown = function (e) {
					e.preventDefault();
					if (selectionObject.isOpen) {
						var self = selectionObject;

						self.$dropdown.hide();
						self.setActiveOption(null);
						self.refreshState();
						self.$control.removeClass('dropdown-active');

						setTimeout(function () {
							self.isOpen = false;
						}, 300);
					}
				};
			});
		}
	}
	setHeightOfTextBoxes();

	if(window.location.hash) {
		if($('[data-anchor="!'+window.location.hash+'"]').length > 0) {
			if($('[data-anchor="!'+window.location.hash+'"]').attr('data-toggle')) {
				$($('[data-anchor="!'+window.location.hash+'"]').data("target")).collapse('show');
			}
			scrollTo($('[data-anchor="!'+window.location.hash+'"]').offset().top);
		}
	}

	$('body').on('click','[data-anchor-ni]', function (e) {
		e.preventDefault();
		var anchorHash = $(this).data("anchor-ni");
		scrollTo($('[data-anchor="!#'+anchorHash+'"]').offset().top);
	})
})

$(window).on('resize', function() {
	setHeightOfNewsCards();
	setHeightOfTeaserBoxes();

	if($('.row.has-2-columns .newsletter-box').length > 0) {
		$('.row.has-2-columns').each(function() {
			if($(this).find('.newsletter-box').length > 0) {
				var boxesHeight = 0;
				var boxes = $(this).find('.newsletter-box__content');
				boxes.attr('style', '');
				boxes.each(function () {
					var objectHeight = $(this).height();
					if (boxesHeight < objectHeight) {
						boxesHeight = objectHeight;
					}
				});
				boxes.height(boxesHeight);
			}
		});
	}

	if($('.job-lt-item').length > 0) {
		var jobLTItemHeight = 0;
		$('.job-lt-item').attr('style','');
		$('.job-lt-item').each(function () {
			var objectHeight = $(this).height();
			if (jobLTItemHeight < objectHeight) {
				jobLTItemHeight = objectHeight;
			}
		});
		$('.job-lt-item').height(jobLTItemHeight);
	}

	if($('.tc-event-item').length > 0) {
		var eventLTItemHeight = 0;
		$('.tc-event-item').each(function () {
			var objectHeight = $(this).height();
			if (eventLTItemHeight < objectHeight) {
				eventLTItemHeight = objectHeight;
			}
		});
		$('.tc-event-item').height(eventLTItemHeight);
	}

	if($('.cbf-job-item > .cbf-job-item-inner').length > 0) {
		var jobLTItemHeight = 0;
		$('.cbf-job-item > .cbf-job-item-inner').each(function () {
			var objectHeight = $(this).height();
			if (jobLTItemHeight < objectHeight) {
				jobLTItemHeight = objectHeight;
			}
		});
		$('.cbf-job-item > .cbf-job-item-inner').height(jobLTItemHeight);
	}

	setHeightOfTextBoxes();
});

/**
 * Add title to FriendlyCaptcha SVG for accessibility check.
 */
window.addEventListener('DOMContentLoaded', function() {

	if (document.querySelector('.mt-4.frc-captcha')) {

		// Add accessible text to FriendlyCaptcha SVG
		let FCSVG;
		const awaitFCSVG = setInterval(() => {
			FCSVG = document.querySelector('.mt-4.frc-captcha svg');
			if (FCSVG) {
				clearInterval(awaitFCSVG);
				const title = document.createElement('title');
				title.textContent = 'FriendlyCaptcha Icon';
				FCSVG.insertBefore(title, FCSVG.firstElementChild);
			}
		}, 50);
	}
});